// ABOUTME: Tint and number colour of the job counter tiles, keyed by CounterType, plus the colour
// ABOUTME: groups used to keep tiles of the same colour on the same row.

import { lighten, Theme } from '@ds/coolshop';

import { CounterType } from '../../../types';

/**
 * Groups counter types by the colour they render in, so tiles of the same colour can be kept
 * on the same row. WARNING and UPDATED share the amber palette; ERROR sits with INFO because
 * the error tile is meant to close the last row next to the neutral counters.
 */
const COLOR_GROUP_ORDER: Record<CounterType, number> = {
    [CounterType.SUCCESS]: 0,
    [CounterType.WARNING]: 1,
    [CounterType.UPDATED]: 1,
    [CounterType.INFO]: 2,
    [CounterType.ERROR]: 2,
};

export const getCounterColorGroup = (type: CounterType) => COLOR_GROUP_ORDER[type] ?? 2;

/** The tile's tint, the tint it takes under the pointer when it opens a drill-down, and the colour
 * of its count. */
type CounterStyle = { background: string; hoverBackground: string; color: string };

export const getCounterStyles = (theme: Theme, type: CounterType): CounterStyle => {
    const tinted = (main: string, dark: string) => ({
        background: lighten(main, 0.9),
        hoverBackground: lighten(main, 0.8),
        color: dark,
    });
    const STYLES: Record<CounterType, CounterStyle> = {
        [CounterType.SUCCESS]: tinted(theme.palette.success.main, theme.palette.success.dark),
        [CounterType.WARNING]: tinted(theme.palette.warning.main, theme.palette.warning.dark),
        [CounterType.UPDATED]: tinted(theme.palette.warning.main, theme.palette.warning.dark),
        [CounterType.INFO]: {
            background: theme.palette.grey[100],
            hoverBackground: theme.palette.grey[200],
            color: theme.palette.grey[800],
        },
        [CounterType.ERROR]: tinted(theme.palette.error.main, theme.palette.error.dark),
    };

    return STYLES[type];
};
